import React, { PureComponent } from 'react';
import { PrimaryButton } from 'appSrc/components/UI';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import { FormTextField, FormSelect, FormToggle } from 'appSrc/components/UI/ReduxForm';
import style from './styles/style.module.css';

class CarouselForm extends PureComponent {
    submitHandler = ( values ) => {
        var data = {
            id: values.id || undefined,
            title: values.title,
            link_url: values.link_url,
            link_text: values.link_text,
            context: values.context,
            context_order: values.context_order || 0,
            status: values.published ? 'published' : 'draft',
            ui_type: values.ui_type,
        };

        this.props.onSubmit( { carousel: data } );
    }
    render() {
        const { handleSubmit } = this.props;

        return (
            <div>
                <Form
                onSubmit={ handleSubmit( this.submitHandler ) }>
                    <div className={ style.topLevel }>
                        <div className={ style.detailsWrapper }>
                            <Field
                            id='title'
                            name='title'
                            label='Title'
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id='link_text'
                            name='link_text'
                            label='Link Text'
                            component={ FormTextField }
                            fullWidth />
                            <Field
                            id='link_url'
                            name='link_url'
                            component={ FormTextField }
                            label='Link URL'
                            fullWidth />

                            <Field
                            id='context'
                            name='context'
                            label='Page'
                            component={ FormSelect }
                            underlineShow={ true }
                            options={ [
                                { text: 'Home Page', value: 'home_page' },
                                { text: '(Product-Focused) NFL Landing Page', value: 'landing_nfl-a' },
                                { text: '(Product-Focused) NFL Landing Footer', value: 'landing_nfl_footer-a' },
                                { text: '(Content-Focused) NFL Landing Page', value: 'landing_nfl-b' },
                                { text: '(Content-Focused) NFL Landing Footer', value: 'landing_nfl_footer-b' },
                                { text: '(Product-Focused) Dance Landing Page', value: 'landing_dance-a' },
                                { text: '(Product-Focused) Dance Landing Footer', value: 'landing_dance_footer-a' },
                                { text: '(Content-Focused) Dance Landing Page', value: 'landing_dance-b' },
                                { text: '(Content-Focused) Dance Landing Footer', value: 'landing_dance_footer-b' },
                                { text: '(Product-Focused) Categories Landing Page', value: 'landing_category-a' },
                                { text: '(Product-Focused) Categories Landing Footer', value: 'landing_category_footer-a' },
                                { text: '(Content-Focused) Categories Landing Page', value: 'landing_category-b' },
                                { text: '(Content-Focused) Categories Landing Footer', value: 'landing_category_footer-b' },
                            ] } />
                            <Field
                            id='context_order'
                            name='context_order'
                            label='Page Order'
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id='ui_type'
                            name='ui_type'
                            label='UI Type'
                            component={ FormSelect }
                            underlineShow={ true }
                            options={ [
                                { text: 'Small Card Carousel', value: 'small_card_carousel' },
                                { text: 'Large Card Carousel', value: 'large_card_carousel' },
                                { text: 'Expanded Card Carousel', value: 'expanded_card_carousel' },
                                { text: 'Narrow Stack', value: 'narrow_card_stack' },
                                { text: 'Product-Focused Card Set (limit 2)', value: 'product-focused_card_set' },
                                { text: 'Product-Focused Card Stack', value: 'product-focused_card_stack' },
                                { text: 'Product-Focused Card Carousel', value: 'product-focused_card_carousel' },
                                { text: 'Content-Focused Card Set (limit 2)', value: 'content-focused_card_set' },
                                { text: 'Content-Focused Card Stack', value: 'content-focused_card_stack' },
                                { text: 'Content-Focused Card Carousel', value: 'content-focused_card_carousel' },
                            ] } />

                            <Field
                            id='published'
                            name='published'
                            label='Published'
                            component={ FormToggle }
                            style={ { marginTop: '10px' } } />

                            <PrimaryButton
                            label='Submit'
                            fullWidth
                            type='submit'
                            style={ { marginTop: '45px' } }/>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}
CarouselForm.defaultProps = {
    initialValues: {},
};

CarouselForm = reduxForm( {
    form: 'CarouselForm',
} )( CarouselForm );

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'CarouselForm', field, value ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( CarouselForm );
